import React from "react";
import type { ElementSize } from "./getElementSize";

/** Screen-space box of a rendered shape, relative to the viewport. */
export interface ShapeScreenRect {
  left: number;
  top: number;
  right: number;
  bottom: number;
}

/**
 * How the editor chrome measures rendered shapes and the pointer. The
 * Konva canvas answers these from the stage (the default when no provider
 * is mounted); another renderer supplies its own implementation so the
 * floating toolboxes and context menu work unchanged on top of it.
 */
export interface ShapeMetrics {
  getScreenRect: (shapeId: string) => ShapeScreenRect | null;
  getElementSize: (shapeId: string) => ElementSize | null;
  /** Last pointer position relative to the canvas container. */
  getPointerPosition: () => { x: number; y: number } | null;
  /** Container-relative screen point to world coordinates. */
  toWorld: (position: { x: number; y: number }) => { x: number; y: number };
  /** PNG export of the editing area; the Konva stage export is the default. */
  exportPng?: (options: {
    width: number;
    height: number;
    pixelRatio?: number;
    filename?: string;
    background?: string;
  }) => Promise<boolean>;
}

export const ShapeMetricsContext = React.createContext<ShapeMetrics | null>(
  null
);

export const useShapeMetrics = (): ShapeMetrics | null =>
  React.useContext(ShapeMetricsContext);
